export const colors = {
    primary: '#001041',
    secondary: '#FFD300',
    white: '#FFFFFF',
    text: {
        primary: '#0D2543',
        secondary: '#BF4D17',
        light: '#91B0DA',
        dark: '#292B32',
        medium: '#454754',
        error: '#C70002',
        placeholder: '#5E616E',
    },
    error: {
        background: '#f44336',
        backgroundLight: '#FFCFDF',
        border: '#FA7AA5',
    },
    background: {
        light: '#EFF3FF',
        lightAlt: '#F0F4FF',
        lightGray: '#F1F1F1',
        dark: '#061645',
        darkAlt: '#000C30',
        darkBlue: '#000E36',
        gradient: 'linear-gradient(180deg, #061645 0%, #000E36 76.44%, #001554 100%)',
        hover: '#f5f5f5',
        selected: '#f0f0f0',
        backdrop: 'rgba(0, 0, 0, 0.5)',
    },
    border: {
        primary: '#0F2A7C',
        light: '#91B0DA',
        lighter: '#BBD5EA',
        lightest: '#EBF3F9',
        input: '#6A7594',
        form: '#D3D5DC',
        gradient: '#124383',
        outline: '#363C4D',
    },
    accent: {
        orange: '#FF6017',
        orangeLight: '#FFA880',
        orangeGradient: '#FF671F',
        orangePeach: '#FFDBCA',
        green: '#247E5B',
        greenLight: '#7DEDC2',
        blue: '#3861A9',
        blueLight: '#79E0FF',
        lightBlue2: '#519EE6',
        lightBlue3: '#6CAFE7',
        mediumBlue: '#1552BC',
        yellow: '#F6C543',
        gray: '#747474',
        lightBlue: '#BBD5EA',
        darkOrange: '#CA4F16'
    },
    shadow: {
        menu: '0px 0px 40px 0px #010C30',
    },
    button: {
        gradient: 'linear-gradient(90deg, #FF9900 0%, #FF671F 100%)',
    },
};

export const spacing = {
    xs: 1,
    sm: 2,
    md: 3,
    lg: 5,
    xl: 8,
    xxl: 11,
    section: 16.5,
};

export const typography = {
    fontFamily: {
        primary: 'Lato',
        heading: 'Montserrat',
    },
    fontSize: {
        xs: 12,
        sm: 14,
        md: 16,
        lg: 18,
        xl: 24,
        xxl: 28,
        xxxl: 36,
    },
};

export const iconFilters = {
    blue: 'brightness(0) saturate(100%) invert(71%) sepia(18%) saturate(629%) hue-rotate(182deg) brightness(101%) contrast(88%)',
    darkBlue: 'invert(2%) sepia(98%) saturate(7482%) hue-rotate(236deg) brightness(97%) contrast(106%)',
    orange: 'brightness(0) saturate(100%) invert(32%) sepia(56%) saturate(1547%) hue-rotate(349deg) brightness(93%) contrast(90%)',
    brightOrange: 'brightness(0) saturate(100%) invert(45%) sepia(98%) saturate(2446%) hue-rotate(1deg) brightness(101%) contrast(101%)',
};

export const gradients = {
    background: 'linear-gradient(180deg, #061645 0%, #000E36 76%, #001554 100%)',
    orange: 'linear-gradient(180deg, #FF6A0B 0%, #FFB800 82.93%)',
    avatarBorder: 'linear-gradient(180deg, #FF6A0B 0%, #FFB800 82.93%)',
    heroLeft: {
        line1: 'linear-gradient(90deg, rgba(255,96,23,0) 0%, #FF6017 10.5%, #FFA880 36%, rgba(255,168,68,0.27) 67%, rgba(255,255,68,0) 99.5%)',
        line2: 'linear-gradient(90deg, #247E5B 0%, #7DEDC2 36%, rgba(38,119,88,0.5) 67%, rgba(53,255,177,0) 99.5%)',
        line3: 'linear-gradient(90deg, rgba(8,26,50,0) 0%, #3861A9 11%, rgba(121,224,255,0.93) 36%, rgba(28,240,247,0.27) 67%, rgba(28,240,247,0) 99.5%)',
        line4: 'linear-gradient(90deg, #F6C543 0%, rgba(255,255,255,0.93) 36%, rgba(255,255,68,0.27) 67%, rgba(255,255,68,0) 99.5%)',
        line5: 'linear-gradient(90deg, rgba(8,27,52,0) 0%, #747474 12.5%, rgba(255,255,255,0.93) 36%, rgba(116,116,116,0.27) 67%, rgba(116,116,116,0) 99.5%)'
    },
    heroRight: {
        line1: 'linear-gradient(90deg, rgba(255,255,68,0) 0.48%, rgba(255,168,68,0.27) 32.7%, #FFA880 63.9%, #FF6017 88%, rgba(255,96,23,0) 100%)',
        line2: 'linear-gradient(90deg, rgba(53,255,177,0) 0.48%, rgba(38,119,88,0.5) 32.7%, #7DEDC2 63.9%, #247E5B 100%)',
        line3: 'linear-gradient(90deg, rgba(28,240,247,0) 0.48%, rgba(28,240,247,0.27) 32.7%, rgba(121,224,255,0.93) 63.9%, #3861A9 90.4%, rgba(56,97,169,0) 100%)',
        line4: 'linear-gradient(90deg, rgba(255,255,68,0) 0.48%, rgba(255,255,68,0.27) 32.7%, rgba(255,255,255,0.93) 63.9%, #F6C543 100%)',
        line5: 'linear-gradient(90deg, rgba(116,116,116,0) 0.48%, rgba(116,116,116,0.27) 32.7%, rgba(255,255,255,0.93) 63.9%, #747474 88.5%, rgba(116,116,116,0) 100%)'
    }
};

export const dotStyle = {
    position: 'absolute',
    borderRadius: '50%',
    backgroundColor: colors.white,
    filter: 'blur(2.25px)'
};

export default {
    API_ENDPOINTS: {
        DOCUMENTATION: '/api/documentation',
        SPECS: '/api/specs',
    },
    ROUTES: {
        HOME: '/',
        DOCS: '/docs',
        API_DETAILS: '/api/:id',
    },
    PAGINATION: {
        DEFAULT_LIMIT: 20,
        MAX_LIMIT: 100,
    },
};